import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { utc: String }

  connect() {
    this.render()
  }

  render() {
    if (!this.utcValue) return

    const date = new Date(this.utcValue)
    if (isNaN(date.getTime())) return

    const prefs = document.getElementById("time-prefs")
    const timezone = prefs?.dataset.timezone || "UTC"
    const use24h = prefs?.dataset.timeFormat === "24h"

    this.element.textContent = new Intl.DateTimeFormat("en-US", {
      timeZone: timezone,
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
      hour12: !use24h
    }).format(date)
  }
}
